import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function About() {
  return (
    <div>
      <div className="bg-[#EFEBE5] px-6 md:px-12 lg:px-24 py-3">
        <div className="max-w-7xl mx-auto flex items-center gap-2 text-sm font-body text-[#6B6B6B]">
          <Link to="/" className="hover:text-[#2D5016]">Accueil</Link>
          <ChevronRight className="w-3 h-3" />
          <span className="text-[#2D5016] font-medium">Qui sommes-nous</span>
        </div>
      </div>

      <section className="py-16 md:py-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-[#C8A951] font-body text-sm tracking-[0.3em] uppercase mb-3">Notre histoire</p>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#2C2C2C]" data-testid="about-title">Marc Dominici — L'ame de VisitMonde</h1>
          </div>

          <div className="grid md:grid-cols-5 gap-12 items-start">
            <div className="md:col-span-2">
              <div className="rounded-xl overflow-hidden aspect-[3/4] shadow-lg">
                <img
                  src="https://customer-assets.emergentagent.com/job_immersive-world-35/artifacts/f1mxad60_IMG_1815_modifi%C3%A9.JPG"
                  alt="Marc Dominici, fondateur de VisitMonde"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="mt-6 p-6 bg-[#2D5016]/5 rounded-xl border-l-4 border-[#C8A951]">
                <p className="font-heading text-lg italic text-[#2C2C2C]">
                  "Le vrai voyage, c'est celui qui transforme. Celui qui ouvre les yeux, qui cree des liens, qui fait de vous un citoyen du monde."
                </p>
                <p className="font-body text-sm text-[#A0522D] mt-2">— Marc Dominici</p>
              </div>
            </div>

            <div className="md:col-span-3 space-y-6 font-body text-base text-[#2C2C2C]/80 leading-relaxed" data-testid="about-content">
              <p>
                Marc Dominici n'est pas un simple professionnel du tourisme. C'est un voyageur dans l'ame, un explorateur passionne qui, depuis plus de 40 ans, sillonne le monde a la recherche de nouveaux sentiers a explorer et de peuples a rencontrer.
              </p>
              <p>
                Createur de tour-operateurs et d'agences de voyages, Marc a toujours refuse le tourisme de masse. Pour lui, le voyage n'a de sens que s'il cree un lien authentique entre les voyageurs et les populations locales. C'est cette conviction profonde qui l'a pousse a creer VisitMonde.
              </p>
              <p>
                VisitMonde est ne d'une idee simple mais puissante : proposer des voyages ou la rencontre humaine est au coeur de chaque experience. Des rizieres de Sapa aux plateaux d'Ethiopie, des temples de Bagan aux iles du Titicaca, chaque circuit est concu pour vous faire vivre une experience unique aupres des peuples du monde.
              </p>
              <p>
                Marc a vecu avec les tribus Palung de Birmanie, ramasse le sel avec les caravaniers du Lac Assal de Djibouti, chez les Hamer d'Ethiopie, partage l'injera avec les familles des hauts plateaux. Chaque rencontre a renforce sa conviction : le voyage est le plus beau cadeau que l'on puisse se faire.
              </p>
              <p>
                L'idee du vrai voyage selon VisitMonde ? Celui qui transforme, qui ouvre les yeux, qui cree des liens indissolubles entre des etres humains que tout separe en apparence. Trois nuits minimum chez l'habitant dans chaque circuit, des groupes limites a 12 personnes, des guides locaux passionnes — voila la recette VisitMonde.
              </p>
              <p>
                L'engagement RSE est au coeur de la philosophie de VisitMonde. Tourisme responsable et solidaire, compensation carbone des vols, soutien direct aux communautes locales, interdiction du plastique a usage unique — Marc s'engage pour un tourisme qui fait du bien, aux voyageurs comme aux populations qui les accueillent.
              </p>
              <p className="text-[#2D5016] font-medium">
                Rejoignez-nous dans cette aventure humaine extraordinaire. Le monde vous attend, et ses peuples ont tant a vous offrir.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
